import {
  makeStyles,
  Theme,
  ButtonProps,
  BoxProps,
  Box,
  Button,
} from '@material-ui/core';
import React, { forwardRef, useMemo } from 'react';
import { FC } from 'react';

export const COLOR_ICON = '#D3D6E9';
const COLOR_MAIN_BACKGROUND = '#F4F6FD';
const COLOR_MAIN_DARK = '#243B4A';
const COLOR_MAIN_DARK_BLUE = '#1E597F';
const COLOR_MAIN_DIVIDER = '#EFF1F8';
export const COLOR_MAIN_GREY = '#535453';
const COLOR_MAIN_LIGHT_BLUE = '#048CDD';
const COLOR_MAIN_WHITE = '#FFFFFF';
const COLOR_MUTED_BLUE = '#DEF3FF';
const COLOR_MUTED_GREEN = '#DBFCF8';
const COLOR_MUTED_ORANGE = '#FFF0E7';
const COLOR_MUTED_RED = '#FFE7EE';
const COLOR_MUTED_SUPER_GREEN = '#D2FFDE';
const COLOR_SECONDARY_ALERT_YELLOW = '#FFC93F';
const COLOR_SECONDARY_BLUE = '#72CAFF';
const COLOR_SECONDARY_DARK_RED = '#D8204C';
const COLOR_SECONDARY_GREEN = '#10C3C3';
const COLOR_SECONDARY_ORANGE = '#FF815A';
const COLOR_SECONDARY_RED = '#FF5A6E';
const COLOR_SECONDARY_SUPER_GREEN = '#55D278';
export const COLOR_TEXT_TEXT = '#657197';

const useStyles = makeStyles((theme: Theme) => {
  const transition = theme.transitions.create(['all'], {
    duration: theme.transitions.duration.short,
  });
  return {
    root: ({ jwType }: { jwType: JWType }) => {
      let borderColor = 'transparent';
      let minWidth;
      let padding;
      let backgroundColor = '#fff';
      let disabledBackgroundColor;
      let disabledBorderColor;
      let disabledColor;
      let hoverBackgroundColor;
      let hoverBorderColor;
      let hoverColor;
      switch (jwType) {
        case 'primary':
          padding = '16px 20px 15px';
          backgroundColor = COLOR_MAIN_LIGHT_BLUE;
          hoverBackgroundColor = '#3999E0';
          hoverBorderColor = '#3999E0';
          disabledBackgroundColor = COLOR_ICON;
          disabledBackgroundColor = COLOR_MUTED_BLUE;
          disabledBorderColor = COLOR_MUTED_BLUE;
          disabledColor = '#fff';
          borderColor = COLOR_MAIN_LIGHT_BLUE as any;
          break;
        case 'for-dark-backgrounds':
          minWidth = 170;
          padding = '14px 14px 13px 14px';
          hoverBackgroundColor = COLOR_MAIN_BACKGROUND;
          hoverBorderColor = COLOR_MAIN_BACKGROUND;
          break;
        case 'outlined':
          borderColor = COLOR_MAIN_BACKGROUND as any;
          padding = '14px 14px 13px 14px';
          hoverBackgroundColor = COLOR_MAIN_LIGHT_BLUE;
          hoverBorderColor = COLOR_MAIN_LIGHT_BLUE;
          hoverColor = '#fff';
          break;
        case 'basic':
        case 'basic-red':
          padding = '12px 13px 11px 13px';
          backgroundColor = 'transparent';
          hoverBackgroundColor = 'transparent';
          hoverBorderColor = COLOR_MAIN_BACKGROUND;
          disabledBorderColor = 'transparent';
          break;
        // case 'primary-red':
        //   padding = '16px 20px 15px';
        //   backgroundColor = theme.palette.secondaryRed;
        //   hoverBackgroundColor = theme.palette.secondaryDarkRed;
        //   hoverBorderColor = theme.palette.secondaryDarkRed;
        //   disabledBackgroundColor = theme.palette.icon;
        //   disabledBackgroundColor = theme.palette.mutedRed;
        //   disabledBorderColor = theme.palette.mutedRed;
        //   disabledColor = theme.palette.mainWhite;
        //   borderColor = theme.palette.secondaryRed as any;
        //   break;
      }

      return {
        fontFamily: 'Gotham Rounded, sans-serif',
        textTransform: 'unset',
        backgroundColor,
        borderWidth: 2,
        borderStyle: 'solid',
        borderRadius: 10,
        lineHeight: '17px',
        borderColor,
        minWidth,
        padding,
        transition,
        textAlign: 'center',
        '&:hover': {
          backgroundColor: hoverBackgroundColor,
          color: hoverColor,
          borderColor: hoverBorderColor,
        },
        '&:disabled': {
          backgroundColor: disabledBackgroundColor,
          borderWidth: 2,
          borderColor: disabledBorderColor,
          color: disabledColor,
        },
      };
    },
  };
});

type JWType =
  | 'for-dark-backgrounds'
  | 'outlined'
  | 'basic'
  | 'basic-red'
  | 'primary-red'
  | 'primary';
export interface JWButtonProps extends ButtonProps {
  jwType: JWType;
  component?: any;
  containerProps?: BoxProps;
}

const JWButton: FC<JWButtonProps> = forwardRef(
  ({ jwType, containerProps, ...props }, ref) => {
    const classes = useStyles({ jwType });
    const color = useMemo(() => {
      let tempColor = '#048CDD';
      switch (jwType) {
        case 'primary':
          tempColor = 'mainWhite';
          break;
        case 'basic-red':
          tempColor = '#FF5A6E';
          break;
        case 'primary-red':
          tempColor = 'mainWhite';
      }
      return tempColor;
    }, [jwType]);
    // HOOKS END

    return (
      <Box color={color} {...containerProps}>
        <Button
          ref={ref}
          {...props}
          variant="outlined"
          color="inherit"
          classes={{
            root: classes.root,
          }}
        />
      </Box>
    );
  }
);

export default JWButton;
